<template>

   <div style="min-height: 100px" v-if="config.payment.paypal.enabled" id="paypal-button"></div>

</template>

<script>
import config from '../config'
import Vue from 'vue'

export default {
    props: {
        'button-color': {
            type: String,
            default: 'white'
        },
        'customer-email': {
            type: String
        },
        'subscription-type': {
            type: String
        },
       'googleToken': {
          type: String
       },
       hadSubscription: { type: Boolean }
    },
    data: ()=>({
        config
    }),
    mounted(){

        if(!config.payment.paypal.enabled){
            return;
        }

       const subscriptionTypes  = {
               withTrial: {
                  Monthly: config.payment.paypal.plans.threeDaysTrial_Monthly_SevenNinetyNine,
                  SemiAnnual: config.payment.paypal.plans.threeDaysTrial_SemiAnnual_FiveNinetyNine,
                  Annual: config.payment.paypal.plans.threeDaysTrial_Annual_ThreeNinetyNine
               },
               withoutTrial: {
                  Monthly: config.payment.paypal.plans.Monthly_SevenNinetyNine,
                  SemiAnnual: config.payment.paypal.plans.SemiAnnual_FiveNinetyNine,
                  Annual: config.payment.paypal.plans.Annual_ThreeNinetyNine

               }
       };

       const _that = this;

        Vue.nextTick(()=>{

            paypal.Buttons({
                style: {
                shape: 'rect',
                color: 'gold',
                layout: 'horizontal',
                label: 'paypal',
                tagline: false
                },

                //notify_url: 'https://backend.GameEnable.com/chargedPaypalIpn/' + this.googleToken,
                createSubscription: (data, actions)=> {

                    return actions.subscription.create({

                        plan_id: this.hadSubscription? subscriptionTypes.withoutTrial[_that.subscriptionType] : subscriptionTypes.withTrial[_that.subscriptionType],
						application_context : { 
							 shipping_preference:'NO_SHIPPING'
						}

                    });

                },
                onApprove: this.onApprove.bind(this)

            }).render( '#paypal-button');

        });

    },
    methods: {

        async onApprove(paymentData){

            this.$emit('loadpaymentdata', paymentData);

        }
    }
};

</script>
